import Vue from 'vue';
import 'element-plus/dist/index.css';
import './assets/css/base.less';
import './assets/css/index.less';
import Zntry from '@zn-collect/monitor';
import { http, omsMainServer } from '@/utils/http';
import api from '@/api';
import { isCustomerSaasPrivate } from '@/utils/globalConfig';
import App from './App.vue';
import router from './router';
import store from './store';
import { sendMonitorData } from './utils/sendMonitorData';
import {aliyunDot} from '@/utils/point';

import './utils/installAntdv';
Vue.config.productionTip = false;
// SaaS 私有化：关闭 Zntry 监控上报
if (!isCustomerSaasPrivate()) {
  const publicInfo = Zntry.attachPublicInfo();
  Zntry.attachErrorHandler(Vue, {}, publicInfo);
  Zntry.responseInterceptor(omsMainServer, publicInfo);
}

Vue.prototype.$http = http;
Vue.prototype.$api = api;
Vue.prototype.$aliyunDot = aliyunDot;

sendMonitorData(store, http);

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');
